import type {Meeting} from '../services/InfinityClient.service';

import {useMe} from './useMe';

export const useAmIApiParticipant = (getMe: Meeting['getMe']) => {
    const me = useMe(getMe);
    return me?.protocol === 'api';
};
